<template>
  <a-layout>
    <a-layout-sider
      id="leftSider"
      v-model:collapsed="collapsed"
      :theme="theme"
      :trigger="null"
      collapsible
    >
      <div class="logo d-flex justify-content-center align-items-center">
        <div v-if="collapsed">
          <img
            src="../../assets/logo-small.png"
            class="mx-auto d-block"
            alt="logo"
          />
        </div>
        <div v-else class="d-flex justify-content-center align-items-center">
          <img src="../../assets/logo-small.png" alt="logo" />
          <h4
            class="fw-bold ms-2 mb-0"
            :class="theme == 'dark' ? 'text-white' : ''"
          >
            Cloud<span class="font-weight-500">Ext</span>
          </h4>
        </div>
      </div>

      <a-menu
        class="menu-list"
        v-model="selectedKeys"
        :theme="theme"
        mode="inline"
        :open-keys="openKeys"
        @openChange="onOpenChange"
      >
        <div v-for="menu in menulist" :key="menu.keyIndex">
          <a-menu-item
            v-if="!menu.subMenuTitle"
            :key="menu.keyIndex"
            :class="
              this.$route.name == menu.routerName
                ? 'ant-menu-item-selected'
                : ''
            "
          >
            <template #title>{{ menu?.name }} </template>
            <router-link
              :to="menu.link"
              class="d-flex align-items-center h-100"
              :class="collapsed ? 'justify-content-center' : ''"
            >
              <vue-feather :type="menu.icon" />
              <span class="title">{{ $t(menu?.name) }}</span>
            </router-link>
          </a-menu-item>
          <div v-if="menu.subMenuTitle">
            <a-sub-menu :key="menu.submenuKey">
              <template #icon>
                <vue-feather :type="menu.subMenIcon" />
              </template>
              <template #title>{{ $t(menu.subMenuTitle) }}</template>
              <a-menu-item
                v-for="submenu in menu.subMenuList"
                :key="submenu?.keyIndex"
                :class="
                  this.$route.name == submenu?.routerName
                    ? 'ant-menu-item-selected'
                    : ''
                "
              >
                <span
                  @click="$router.push(submenu?.link)"
                  class="subMenu d-flex align-items-center"
                >
                  <vue-feather :type="submenu?.icon" />
                  <span class="title">
                    {{ submenu?.name ? $t(submenu?.name) : "" }}
                  </span>
                </span>
              </a-menu-item>
            </a-sub-menu>
          </div>
        </div>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header
        id="header"
        :theme="theme"
        :class="theme == 'light' ? 'bg-white' : 'bg-dark-mode'"
        class="d-flex justify-content-between align-items-center px-3"
      >
        <div class="d-flex align-items-center">
          <vue-feather
            type="menu"
            class="trigger pointer"
            :class="theme == 'dark' ? 'text-white' : 'text-primary'"
            @click="collapsed = !collapsed"
          />
          <div class="ms-2">
            <a-tooltip placement="bottom">
              <template #title>
                <template v-if="domain?.crm_company?.name">
                  <span class="fs-6 fw-400">Name : </span>
                  {{ domain?.crm_company?.name ?? "" }}
                  <br />
                </template>
                <template v-if="domain?.crm_company?.mobile_number">
                  <span class="fs-6 fw-400">Mobile : </span>
                  {{ domain?.crm_company?.mobile_number ?? "" }}
                  <br />
                </template>
                <template v-if="domain?.crm_company?.email">
                  <span class="fs-6 fw-400">E-Mail : </span>
                  {{ domain?.crm_company?.email ?? "" }}
                  <br />
                </template>
                <template v-if="domain?.crm_company?.address_line_first">
                  <span class="fs-6 fw-400">Address : </span>
                  {{ domain?.crm_company?.address_line_first ?? "" }}
                  <br />
                </template>
                <template v-if="domain?.crm_company?.city">
                  <span class="fs-6 fw-400">City : </span>
                  {{ domain?.crm_company?.city ?? "" }},
                  {{ domain?.crm_company?.state ?? "" }}
                  <br />
                </template>
                <template v-if="domain?.crm_company?.country">
                  <span class="fs-6 fw-400">Country : </span>
                  {{ domain?.crm_company?.country ?? "" }},
                  {{ domain?.crm_company?.zip_code ?? "" }}
                  <br />
                </template>
              </template>
              <div class="d-flex align-items-center">
                <vue-feather
                  v-if="domain?.crm_company?.name"
                  type="zap"
                  class="text-success"
                  size="1.1rem"
                />
                <p class="company-name font-weight-500 d-none d-lg-block mb-0">
                  {{ domain?.crm_company?.name ?? "" }}
                </p>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="d-flex align-items-center">
          <template v-if="is_open_admin">
            <div
              v-if="user && !notNormalUserType.includes(user.user.user_type)"
              class="d-md-block"
            >
              <span>
                <a-dropdown :trigger="['click']" class="border-0">
                  <template #overlay v-if="accessDomain.length !== 0">
                    <a-menu>
                      <a-menu-item
                        v-for="(item, index) in accessDomain"
                        :key="index"
                        @click="changeDomain(item.domain_uuid)"
                      >
                        <span
                          :class="{
                            'text-primary': item.domain_name === selectedDomain,
                          }"
                        >
                          {{ item.domain_name }}
                        </span>
                      </a-menu-item>
                    </a-menu>
                  </template>
                  <a-button>
                    <span class="text-primary">
                      <b>{{ domain?.domain_name }}</b>
                    </span>
                    <DownOutlined />
                  </a-button>
                </a-dropdown>
              </span>
            </div>
            <div v-else>
              <span class="domain-name text-primary d-none d-lg-block">
                {{ `${domain ? domain.domain_name : "Domain"} ` }}
              </span>
            </div>
            <vue-feather
              type="phone"
              @click="getActiveCalls()"
              :class="theme == 'dark' ? 'text-white' : 'text-dark'"
              class="pointer mx-2 mx-xl-3"
            />
            <router-link class="d-flex align-items-center" to="/registrations">
              <vue-feather
                type="user-plus"
                :class="theme == 'dark' ? 'text-white' : 'text-dark'"
                class="pointer mx-2"
              />
            </router-link>
          </template>
          <p
            v-if="
              !is_open_admin &&
              user &&
              user.user?.user_permission['Domain']?.is_view
            "
            :class="theme == 'light' ? 'text-dark' : 'text-light'"
            class="pointer mb-0 me-3"
            @click="showDomainList"
          >
            Domain
          </p>
          <a-badge
            :count="notiCount"
            :title="`${notiCount} Unchecked Alerts`"
            size="small"
            :overflow-count="999"
            class="mx-2"
            v-if="
              user &&
              user.user &&
              (user.user.user_type == 'super_admin' ||
                user.user.user_type == 'pbx_admin_staff') &&
              !is_open_admin
            "
            @click="showAlert()"
          >
            <vue-feather
              v-if="
                user &&
                user.user &&
                (user.user.user_type == 'super_admin' ||
                  user.user.user_type == 'pbx_admin_staff') &&
                !is_open_admin
              "
              class="pointer mx-0"
              :class="theme == 'light' ? 'text-dark' : 'text-light'"
              type="bell"
            />
          </a-badge>
          <vue-feather
            class="pointer mx-2"
            :type="theme == 'light' ? 'moon' : 'sun'"
            @click="changeTheme(theme == 'light' ? 'dark' : 'light')"
            :class="theme !== 'light' ? 'text-white' : ''"
          />
          <template v-if="is_open_admin">
            <div
              class="locale-changer d-none d-sm-block mx-2 mx-xl-3"
              v-if="!isResellerAdmin"
            >
              <a-select
                ref="select"
                v-model:value="$i18n.locale"
                :bordered="false"
              >
                <a-select-option
                  v-for="locale in availableLocales"
                  :key="`locale-${locale}`"
                  :value="locale.language"
                >
                  <img
                    :src="`${locale.flag}`"
                    alt="user-image"
                    class="me-1"
                    height="12"
                  />
                  <span class="d-none d-md-inline">{{ locale.title }}</span>
                </a-select-option>
              </a-select>
            </div>
          </template>
          <span class="mx-2" v-if="user && user.user">
            <a-avatar
              :src="user.user.profile_picture"
              v-if="user.user.profile_picture"
            />
            <a-avatar style="color: #f56a00; background-color: #fde3cf" v-else>
              {{ String(user.user.first_name).charAt(0) }}
            </a-avatar>
          </span>
          <a-dropdown :trigger="['click']" v-if="user">
            <a class="ant-dropdown-link text-decoration-none" @click.prevent>
              {{
                user && user.user
                  ? user.user.first_name
                    ? user.user.first_name
                    : "" + " " + user.user.last_name
                    ? user.user.last_name
                    : ""
                  : "Super Admin"
              }}
              <DownOutlined />
            </a>
            <template #overlay>
              <a-menu
                :class="
                  theme == 'light' ? 'bg-white' : 'bg-dark-mode header-dropdown'
                "
              >
                <a-menu-item v-if="is_open_admin">
                  <router-link
                    to="/edit-account-details"
                    class="d-flex align-items-center text-decoration-none"
                    v-permission="{
                      routeName: 'Edit Account',
                      action: 'is_view',
                    }"
                  >
                    <vue-feather type="settings" />
                    {{ $t("header_option.Account Settings") }}
                  </router-link>
                </a-menu-item>
                <a-menu-item v-if="is_open_admin">
                  <router-link
                    to="/notes"
                    class="d-flex align-items-center text-decoration-none"
                    v-permission="{
                      routeName: 'Edit Domain Notes',
                      action: 'is_view',
                    }"
                  >
                    <vue-feather type="book" />
                    {{ $t("header_option.Notes") }}
                  </router-link>
                </a-menu-item>
                <a-menu-item
                  v-if="
                    user &&
                    user.user &&
                    !notNormalUserType.includes(user.user.user_type)
                  "
                  v-permission="{
                    routeName: 'Edit Domain',
                    action: 'is_view',
                  }"
                >
                  <router-link
                    to="/edit-domain-details"
                    class="d-flex align-items-center text-decoration-none"
                  >
                    <vue-feather type="phone-call" />
                    {{ $t("header_option.Domain Settings") }}
                  </router-link>
                </a-menu-item>
                <a-menu-item
                  v-if="
                    user?.user &&
                    mktDevice.length !== 0 &&
                    notNormalUserType.includes(user.user.user_type)
                  "
                >
                  <a
                    href="javascript:;"
                    class="d-flex align-items-center text-decoration-none"
                    @click="
                      () => {
                        isDeviceDrawer = true;
                      }
                    "
                  >
                    <vue-feather type="monitor" />
                    {{ "Mikrotik Device/s" }}
                  </a>
                </a-menu-item>
                <a-menu-item
                  v-if="
                    is_open_admin ||
                    ['pbx_admin_staff', 'super_admin'].includes(
                      user?.user?.user_type,
                    )
                  "
                  v-permission="{
                    routeName: 'Mobile App User',
                    action: 'is_view',
                  }"
                >
                  <a
                    href="javascript:;"
                    class="d-flex align-items-center text-decoration-none"
                    @click="mobileApp"
                  >
                    <vue-feather type="smartphone" />
                    {{ $t("header_option.Mobile App") }}
                  </a>
                </a-menu-item>
                <!-- <a-menu-item
                  v-if="
                    is_open_admin ||
                    ['pbx_admin_staff', 'super_admin'].includes(
                      user?.user?.user_type
                    )
                  "
                >
                  <a
                    href="javascript:;"
                    class="d-flex align-items-center text-decoration-none"
                    v-permission="{
                      routeName: 'Contact Book List',
                      action: 'is_view',
                    }"
                    @click="contactBook"
                  >
                    <vue-feather type="list" />
                    {{ "Contact Book" }}
                  </a>
                </a-menu-item> -->
                <a-menu-item @click="logoutUser">
                  <a href="javascript:;" class="text-decoration-none">
                    <vue-feather type="log-out" class="text-danger" />
                    {{ $t("header_option.Logout") }}
                  </a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </a-layout-header>
      <slot />
      <div>
        <WebRTCcall v-if="is_open_admin" />
      </div>
    </a-layout>
  </a-layout>
  <a-modal
    width="1000px"
    v-model:visible="addModel"
    :title="`${$t('active_calls.Active Calls')}`"
    style="top: 20px"
    :footer="null"
  >
    <a-card>
      <div class="table-title">
        <a-table :loading="loading" :dataSource="dataSource" :columns="columns">
          <template #title>
            <div class="d-flex align-items-center flex-wrap">
              <div class="d-inline-flex align-items-center">
                <h4 class="text-primary mb-0 d-inline">
                  {{ $t("active_calls.Active Calls") }}
                  ({{ dataSource.length }})
                </h4>
              </div>
            </div>
          </template>
        </a-table>
      </div>
    </a-card>
  </a-modal>

  <a-drawer
    :title="`Domains ( ${filteredDomain.length} )`"
    placement="right"
    :closable="false"
    :visible="isLeftSideDrawer"
    @close="showDomainList"
  >
    <a-input
      type="search"
      ref="focusField"
      placeholder="Domain Search..."
      v-model:value="domain_search_keyward"
    />
    <ul
      class="domain-list"
      :class="theme == 'light' ? 'bg-white' : 'bg-dark-mode'"
    >
      <li
        class="p-2 my-2"
        v-for="(domain, index) in filteredDomain"
        :key="index"
        @click="openDomain(domain.domain_uuid)"
      >
        <a-button size="small" class="d-flex align-items-center w-100">
          <vue-feather type="external-link" class="pointer text-success" />
          {{ domain.domain_name }} - {{ domain.pbx }}
        </a-button>
      </li>
    </ul>
  </a-drawer>

  <a-drawer
    :title="`Mikrotik Device/s ( ${mktDevice.length} )`"
    placement="right"
    :closable="false"
    :visible="isDeviceDrawer"
    @close="
      () => {
        isDeviceDrawer = false;
      }
    "
  >
    <ul
      class="domain-list"
      :class="theme == 'light' ? 'bg-white' : 'bg-dark-mode'"
    >
      <li
        class="p-2 my-2"
        v-for="(mktd, index) in mktDevice"
        :key="index"
        @click="openDevice(mktd.mikrotik_uuid)"
      >
        <DataView
          :data="mktd"
          :hasTitle="true"
          :showDomain="false"
          :title="mktd.serial_number"
        />
      </li>
    </ul>
  </a-drawer>
</template>
<script>
import PropertyUserService from "@/helpers/apiServices/superAdmin/propertyUser.service";
import {
  layoutComputed,
  layoutMethods,
  authComputed,
  authMethods,
} from "@/store/helpers";
import DataView from "@/views/superAdmin/Network/Mikrotik/DataView.vue";
import RegistrationService from "@/helpers/apiServices/registration.service.js";
import DomainService from "@/helpers/apiServices/superAdmin/domain.service";
import errorHandler from "@/helpers/errorHandler.js";
import { DownOutlined } from "@ant-design/icons-vue";
import WebRTCcall from "@/components/WebRTCcall.vue";
import { menulist } from "@/helpers/menu.js";
import { message } from "ant-design-vue";
import MKTDeviceService from "@/helpers/apiServices/mikrotikDevice.service";

export default {
  name: "App",
  data() {
    return {
      selectedKeys: ["1"],
      collapsed: false,
      menulist,
      addModel: false,
      rootSubmenuKeys: [],
      openKeys: [],
      availableLocales: [
        {
          flag: require("@/assets/img/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/img/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/img/flags/spain.jpg"),
          language: "es",
          title: "Spanish",
        },
        {
          flag: require("@/assets/img/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/img/flags/japanese.png"),
          language: "ja",
          title: "Japanese",
        },
      ],
      columns: [
        {
          title: this.$t("active_calls.direction"),
          dataIndex: "direction",
          key: "direction",
        },
        {
          title: this.$t("active_calls.cid_name"),
          dataIndex: "cid_name",
          key: "cid_name",
        },
        {
          title: this.$t("active_calls.cid_num"),
          dataIndex: "cid_num",
          key: "cid_num",
        },
        {
          title: this.$t("active_calls.callee_name"),
          dataIndex: "callee_name",
          key: "callee_name",
        },
        {
          title: this.$t("active_calls.callee_num"),
          dataIndex: "callee_num",
          key: "callee_num",
        },
        {
          title: this.$t("active_calls.dest"),
          dataIndex: "dest",
          key: "dest",
        },
        {
          title: this.$t("active_calls.callstate"),
          dataIndex: "callstate",
          key: "callstate",
        },
      ],
      dataSource: [],
      loading: false,
      accessDomain: [],
      selectedDomain: "",
      isSuperAdmin: false,
      isResellerAdmin: false,
      isLeftSideDrawer: false,
      notNormalUserType: ["pbx_reseller", "super_admin", "pbx_admin_staff"],
      domainList: [],
      domain_search_keyward: "",
      is_open_admin: false,
      notiCount: 0,
      mktDevice: [],
      intervalId: null,
      count: 0,
      isDeviceDrawer: false,
    };
  },
  components: { DownOutlined, WebRTCcall, DataView },
  computed: {
    ...authComputed,
    ...layoutComputed,
    filteredDomain() {
      return this.updatedItems.filter((item) => {
        return (
          item.domain_name
            .toLowerCase()
            .includes(this.domain_search_keyward.toLowerCase()) &&
          item.domain_enabled == "true"
        );
      });
    },
    updatedItems() {
      return this.domainList.filter((item) => {
        return /[a-zA-Z]/.test(item?.domain_name.replace(/\./g, ""));
      });
    },
  },
  mounted() {
    this.manageMenues();
    this.handleDomain();
    this.selectedDomain = sessionStorage.getItem("domain_uuid");
    if ([undefined, null].includes(this.domains) || this.domains.length == 0) {
      if (this.user) {
        this.getDomain();
      }
    } else {
      this.domainList = this.domains;
    }
    this.intervalId = setInterval(async () => {
      if (this.domain?.domain_uuid) {
        await this.getPptpDevice(`?domain_uuid=${this.domain.domain_uuid}`);
      }
    }, 3000);
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  watch: {
    "$i18n.locale": function () {
      this.columns.forEach((element) => {
        element.title = this.$t("active_calls." + element.key);
      });
    },
  },
  methods: {
    ...authMethods,
    ...layoutMethods,
    manageMenues() {
      this.isSuperAdmin = ["pbx_admin_staff", "super_admin"].includes(
        this.user?.user?.user_type,
      )
        ? true
        : false;
      if (this.isSuperAdmin) {
        this.getAlertList();
      }
      this.isResellerAdmin =
        this.user?.user?.user_type == "pbx_reseller" ? true : false;
      const isNewTab = sessionStorage.getItem("is_open_admin");
      let menuItems = [];

      // let urlData = {
      //   "CDR Details": {
      //     is_edit: false,
      //     is_view: true,
      //     is_delete: false,
      //   },
      // };
      // console.log(urlData);
      if (
        this.user &&
        Object.keys(this.user.user.user_permission).length !== 0
      ) {
        this.menulist.map((item) => {
          if (item.subMenuList && Array.isArray(item.subMenuList)) {
            let subItemArr = [];
            item.subMenuList = item.subMenuList.map((sub_item) => {
              const subMenuName =
                this.user.user.user_permission[sub_item?.name];
              if (
                (subMenuName && subMenuName.is_view) ||
                [
                  "Mikrotik Devices",
                  "Queue Summary Reports",
                  "Queue Reports",
                  "Agent Reports",
                  "IP Whitelist",
                ].includes(sub_item?.name)
              ) {
                subItemArr.push(sub_item);
              }
            });
            if (subItemArr.length !== 0) {
              menuItems.push({
                ...item,
                subMenuList: subItemArr,
              });
            }
          } else {
            const menuName = this.user.user?.user_permission[item?.name];
            if ((menuName && menuName.is_view) || item?.name === "Messaging") {
              menuItems.push(item);
            }
          }
        });
      } else {
        menuItems = this.menulist;
      }
      menuItems = menuItems.filter((item) => {
        if (["", null, undefined].includes(this.domain?.crm_company_id)) {
          if (item.submenuKey !== "sub3") {
            return item;
          }
          return;
        }
        return item;
      });
      this.menulist = menuItems.filter((item) => {
        if (this.isSuperAdmin && item.isSuperAdmin && !isNewTab) {
          return item;
        }
        if (this.isResellerAdmin && item.isResellerAdmin && !isNewTab) {
          return item;
        }
        if (isNewTab == "true") {
          this.is_open_admin = true;
          if (
            item.requiredRole.includes(this.user.user.user_type) &&
            !item.isSuperAdmin
          ) {
            return item;
          }
        }
      });
      this.menulist.map((item) => {
        if (item.subMenuList) {
          this.rootSubmenuKeys.push(item.submenuKey);
        }
      });
      // if (!sessionStorage.isLoadMainPage && !this.isSuperAdmin) {
      //   setTimeout(() => {
      //     this.manageMenues();
      //   }, 200);
      // }
    },
    // Method is used to get domain list
    getDomain() {
      if (this.user.user.access_domain) {
        this.domainList = this.user.user?.access_domain;
        return;
      }
      DomainService.getDomainList()
        .then((response) => {
          if (response.status) {
            this.setDomains(response.result);
            this.domainList = response.result;
          } else {
            message.warn(response.message);
          }
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is used to get alert list
    getAlertList() {
      PropertyUserService.getAlertsList(`?page_size=1&is_check=0`)
        .then((response) => {
          if (!response.status) {
            message.warning(response.message);
            this.notiCount = 0;
            return;
          }
          this.notiCount = response.count;
        })
        .catch((error) => {
          this.notiCount = 0;
          errorHandler(error);
        });
    },
    // Method is used to handle domain
    handleDomain() {
      if (this.user && Array.isArray(this.user.user?.access_domain)) {
        this.accessDomain = this.user.user.access_domain;
      } else {
        this.accessDomain = this.domains;
      }
    },
    // Method is used to logout user
    logoutUser() {
      message.success("Logout successful !!");
      this.logout();
      this.$router.push("/login");
    },
    // Method is used to handle open side bar
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1,
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    // Method is used to handle domain change
    changeDomain(domain_id) {
      sessionStorage.setItem("domain_uuid", domain_id);
      this.setDomain(domain_id)
        .then(() => {
          this.$router.push("/dashboard");
        })
        .catch((error) => {
          if (error.response.status == 401) {
            if (error.response.data.code == "user_not_found") {
              this.$router.push("/logout");
              this.logout();
            }
          }
        });
    },
    // Method is used to get active call list
    async getActiveCalls() {
      this.addModel = true;
      this.loading = true;
      try {
        await RegistrationService.getActiveCallList().then((response) => {
          this.loading = false;
          if (response.status == false) {
            return message.warning(response.message);
          } else {
            this.dataSource = response.result;
          }
        });
      } catch (error) {
        this.loading = false;
      }
    },
    // Method is used to show domain list
    showDomainList() {
      this.isLeftSideDrawer = !this.isLeftSideDrawer;
      this.domain_search_keyward = "";
      if (this.isLeftSideDrawer) {
        setTimeout(() => {
          this.$refs.focusField.focus();
        }, 1000);
      }
    },
    // Method is used to open domain details
    openDomain(domain_uuid) {
      this.isLeftSideDrawer = false;
      window.open(`/dashboard?domain_uuid=${domain_uuid}`, "_blank");
    },
    // Method is used to open mobile app list
    mobileApp() {
      this.$router.push("/mobile-app-provisioning-users?page_size=100");
    },
    // Method is used to open mobile app list
    contactBook() {
      this.$router.push("/contact-book-users?page_size=100");
    },
    // Method is used to open alert list
    showAlert() {
      this.$router.push("/alerts?page_size=100&is_check=0");
    },
    async getPptpDevice(filter) {
      this.count += 1;
      if (this.mktDevice.length !== 0) {
        clearInterval(this.intervalId);
      }

      if (this.count === 3) {
        clearInterval(this.intervalId);
      }

      if (
        !["pbx_admin_staff", "super_admin"].includes(this.user?.user?.user_type)
      ) {
        return;
      }

      try {
        const res = await MKTDeviceService.getPPTPUserList(filter);
        if (!res.status) {
          return;
        }
        this.mktDevice = res.result;
      } catch (err) {
        errorHandler(err);
      }
    },
    openDevice() {},
  },
};
</script>
